import ObjectivesPopup from './ObjectivesPopup';

export default ObjectivesPopup;
